import React from 'react'
import { Lock, Headphones, UsersRound, Flame, BarChart3, Plane } from 'lucide-react'

const Features = () => {
  const features = [
    {
      icon: Lock,
      title: 'Smart App Locking',
      description:
        'Choose from 1,000+ apps to lock. Prayer Mode uses iOS Screen Time API and Android AccessibilityService to actually block access—not just reminders you\'ll ignore. Emergency "End Early" requires 3-second hold to prevent accidental exits.',
      badge: '85% session completion rate',
    },
    {
      icon: Headphones,
      title: '600+ Guided Devotions',
      description:
        'From 5-minute "Morning Grace" to 20-minute "Deep Dives," choose devotions by topic (anxiety, gratitude, forgiveness), speaker, or length. New content weekly. Download 10 (Free) or 50 (Premium) for offline prayer.',
      badge: '4.8★ avg rating',
    },
    {
      icon: UsersRound,
      title: 'Prayer Pods (Social Accountability)',
      description:
        'Create private Pods for your small group (2-10 members) or join public ones. Real-time leaderboard updates when anyone prays. Send encouragement messages. Celebrate milestones together. Free users get 1 Pod, Premium gets unlimited.',
      badge: '2.3x retention boost for Pod members',
    },
    {
      icon: Flame,
      title: 'Streak Tracking & Milestones',
      description:
        'Pray ≥5 minutes daily to maintain your streak. Grace period extends until 3am (because late-night prayers count!). Unlock badges at 3, 7, 14, 30, 60, 100, 365 days. Premium users get 1 "Streak Freeze" per month for vacations.',
      badge: '30% hit 7-day streaks in first month',
    },
    {
      icon: BarChart3,
      title: 'Sunday Prayer Stats (Premium)',
      description:
        'Every Sunday, Premium users get analytics: total minutes prayed, sessions completed, mood trends (track how you feel post-prayer), best prayer times, and week-over-week comparisons. Export your full prayer history as CSV.',
      badge: 'Premium-only feature',
    },
    {
      icon: Plane,
      title: 'Offline & Cross-Platform',
      description:
        'Download devotions for airplane mode. Works on iOS 16+ and Android 8+. Seamless sync across devices. Lock screen playback controls. Background audio continues even if you minimize the app.',
      badge: 'Works offline',
    },
  ]

  return (
    <section className="section-padding bg-grace-gray">
      <div className="container-custom">
        {/* Headline */}
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-heading-dark mb-4">
            Everything You Need to Build a{' '}
            <span className="text-gradient">Lasting Prayer Habit</span>
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <div
                key={index}
                className="card animate-on-scroll"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-lg bg-prayer-blue/10 flex items-center justify-center">
                      <Icon size={28} className="text-prayer-blue" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-heading-dark mb-2">{feature.title}</h3>
                    <p className="text-body-gray leading-relaxed mb-3">{feature.description}</p>
                    <div className="inline-block text-xs font-semibold text-prayer-blue bg-prayer-blue/10 rounded-full py-1 px-3">
                      {feature.badge}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 animate-on-scroll">
          <a href="#download" className="btn-primary text-lg inline-block">
            Get Started Free
          </a>
        </div>
      </div>
    </section>
  )
}

export default Features
